import './SignDocumentBlurOverlay.css'

interface IconProps {
  fillColor: string
  backgroundColor: string
}

export const SignDocumentBlurOverlay = (props: IconProps) => {
  return (
    <div className="generic__blur-overlay">
      <svg
        aria-hidden="true"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="blur-overlay__rect"
          width="120"
          height="120"
          fill={props.backgroundColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.9998 29.3333C43.0631 29.3333 29.3332 43.0632 29.3332 60C29.3332 76.9367 43.0631 90.6666 59.9998 90.6666C76.9366 90.6666 90.6665 76.9367 90.6665 60C90.6665 43.0632 76.9366 29.3333 59.9998 29.3333ZM26.6665 60C26.6665 41.5905 41.5903 26.6666 59.9998 26.6666C78.4093 26.6666 93.3332 41.5905 93.3332 60C93.3332 78.4094 78.4093 93.3333 59.9998 93.3333C41.5903 93.3333 26.6665 78.4094 26.6665 60ZM70.9511 52.399C71.4671 52.9244 71.4595 53.7686 70.9341 54.2846L56.4156 68.5438L49.7237 61.8519C49.203 61.3312 49.203 60.4869 49.7237 59.9662C50.2444 59.4455 51.0886 59.4455 51.6093 59.9662L56.4325 64.7895L69.0655 52.382C69.5909 51.866 70.4351 51.8736 70.9511 52.399Z"
          fill={props.fillColor}
        />
      </svg>
    </div>
  )
}
